module.exports = __webpack_public_path__ + "img/presenter_naito@2x.cefcacf0.jpg";